import React, { useMemo } from 'react';
import componentsClasses from '@app/styles/components.module.css';
import { generateWhatsappLink } from '@app/utils/whatsapp';
import { Container } from './styles';

type Props = {
  whatsapp: string;
};

export default function LeadWarning({ whatsapp }: Props) {
  const link = useMemo(() => {
    return generateWhatsappLink(whatsapp, 'Estou tentando fazer um pedido mas o seu Cardápio Digital está off-line...');
  }, [whatsapp]);

  return (
    <Container>
      <p>O Cardápio Digital está off-line...</p>
      <a href={link} target="_blank">
        <button className={componentsClasses.successButton}>
          <span>Avisar o estabelecimento</span>
        </button>
      </a>
    </Container>
  );
}
